"use strict";
/* globals module */
/**
 * @module MediaGalleryRoute
 * @description Baasic Media Gallery Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var MediaGalleryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryRoute, _super);
    function MediaGalleryRoute(appOptions, mediaGalleryBatchRoute, mediaGallerySettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        _this.mediaGallerySettingsRoute = mediaGallerySettingsRoute;
        _this.findRoute = 'media-galleries/{?searchQuery,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-galleries/{id}/{?embed,fields}';
        _this.updateRoute = 'media-galleries/{id}';
        _this.deleteRoute = 'media-galleries/{id}';
        _this.createRoute = 'media-galleries/';
        _this.purgeRoute = 'media-galleries/purge';
        return _this;
    }
    Object.defineProperty(MediaGalleryRoute.prototype, "batch", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryRoute.prototype, "settings", {
        get: function () {
            return this.mediaGallerySettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media gallery properties using the phrase search.
     * - `ids` - Comma separated list of media gallery ids to be retrieved.       *
     * - `from` - The from date.
     * - `to` - The to date.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media gallery subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media gallery property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example mediaGalleryRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaGalleryRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param id Media gallery id which uniquely identifies media gallery resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example mediaGalleryRoute.get({id: '<media-gallery-id>'});
     **/
    MediaGalleryRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param data Media gallery object used to update specific Media gallery resource in the system.
     * @example mediaGalleryRoute.update(data);
     **/
    MediaGalleryRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param data Media gallery object of specific Media gallery resource in the system.
     * @example mediaGalleryRoute.delete(<media-gallery>);
     **/
    MediaGalleryRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
    * Parses create route; this URI template doesnt support any additional options.
    * @method
    * @param data An media gallery  object that needs to be inserted into the system.
    * @example mediaGalleryRoute.create(data);
    **/
    MediaGalleryRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses purge route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryPurgeRoute.purge();
     **/
    MediaGalleryRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    var _a, _b, _c;
    MediaGalleryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaGalleryBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaGallerySettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MediaGalleryBatchRoute !== "undefined" && _1.MediaGalleryBatchRoute) === "function" ? _b : Object, typeof (_c = typeof _1.MediaGallerySettingsRoute !== "undefined" && _1.MediaGallerySettingsRoute) === "function" ? _c : Object])
    ], MediaGalleryRoute);
    return MediaGalleryRoute;
}(common_1.BaseRoute));
exports.MediaGalleryRoute = MediaGalleryRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
